// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__rPTVP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2OgBS"};